import React from 'react';
import { motion } from 'framer-motion';
import { RotateCcw } from 'lucide-react';
import { Link } from 'react-router-dom';

const LegalPage = ({ title, icon: Icon, children }) => (
  <div className="min-h-screen bg-gray-950 pt-24 pb-16 px-4">
    <div className="max-w-3xl mx-auto">
      <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
          <Icon size={14} className="text-primary-400" />
          <span className="text-sm text-primary-300">Legal</span>
        </div>
        <h1 className="text-4xl font-bold text-white mb-4">{title}</h1>
        <p className="text-gray-500 text-sm">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </motion.div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }}
        className="bg-gray-900/50 border border-gray-800/60 rounded-2xl p-8 prose prose-invert prose-sm max-w-none">
        {children}
      </motion.div>
    </div>
  </div>
);

const RefundPolicy = () => (
  <LegalPage title="Refund Policy" icon={RotateCcw}>
    <h2>1. Eligibility for Refund</h2>
    <p>You are eligible for a full refund if:</p>
    <ul>
      <li>We fail to deliver your foreign TikTok account within 48 hours of payment confirmation</li>
      <li>The account delivered is not in the country you specified during your order</li>
      <li>You experience a technical issue on our end that prevents account creation</li>
    </ul>

    <h2>2. Non-Refundable Situations</h2>
    <p>Refunds will not be issued if:</p>
    <ul>
      <li>You provided incorrect email details during the order</li>
      <li>The account was delivered but you failed to secure the login credentials</li>
      <li>TikTok suspends or bans the account after delivery due to your activity</li>
      <li>You change your mind after the account has been created</li>
      <li>You violated TikTok's Terms of Service</li>
    </ul>

    <h2>3. How to Request a Refund</h2>
    <ol>
      <li>Contact our support team via WhatsApp or email</li>
      <li>Provide your order email and reason for the refund request</li>
      <li>Our team will review your request within 24 hours</li>
      <li>If approved, the refund will be processed within 3-5 business days</li>
    </ol>

    <h2>4. Refund Process</h2>
    <ul>
      <li>Refunds are processed to the original payment method</li>
      <li>You will receive an email confirmation when the refund is processed</li>
      <li>Bank processing times may vary (typically 3-5 business days)</li>
    </ul>

    <h2>5. Contact for Refunds</h2>
    <p>To request a refund, please contact us at:</p>
    <ul>
      <li>Email: contact@advanceadverttvdigital.com</li>
      <li>WhatsApp: Use the link on our <Link to="/support" className="text-primary-400 hover:text-primary-300">Support page</Link></li>
    </ul>
  </LegalPage>
);

export default RefundPolicy;
